import { IconAbc, IconBookOpen, IconCog, IconMagnifyingGlass, IconPuzzle } from '@/components/icons';
import type { LearnerTabIconName } from '@/components/LearnerTabIcon';

export const LEARNER_MOBILE_NAV: readonly {
  to: string;
  label: string;
  icon: LearnerTabIconName;
}[] = [
  { to: '/app/resources', label: 'Learn', icon: 'learn' },
  { to: '/app/alphabet', label: 'Alphabet', icon: 'alphabet' },
  { to: '/app/search', label: 'Search', icon: 'search' },
  { to: '/app/settings', label: 'Settings', icon: 'settings' },
];

export const LEARNER_DESKTOP_NAV = [
  { to: '/app/resources', label: 'Learn', icon: IconBookOpen },
  { to: '/app/games', label: 'Games', icon: IconPuzzle },
  { to: '/app/alphabet', label: 'Alphabet', icon: IconAbc },
  { to: '/app/search', label: 'Search', icon: IconMagnifyingGlass },
  { to: '/app/settings', label: 'Settings', icon: IconCog },
] as const;

export function learnerNavActive(pathname: string, to: string) {
  if (to === '/app/resources') {
    return (
      pathname === '/app/resources' ||
      pathname.startsWith('/app/resources?') ||
      pathname.startsWith('/app/flashcards') ||
      pathname.startsWith('/app/sheets') ||
      pathname.startsWith('/app/storybooks') ||
      pathname.startsWith('/app/songs') ||
      pathname.startsWith('/app/diagrams')
    );
  }
  if (to === '/app/games') {
    return pathname === '/app/games' || pathname.startsWith('/app/games/') || pathname.startsWith('/app/crosswords');
  }
  return pathname === to || pathname.startsWith(`${to}/`);
}
